import React, { useState } from "react";
import { Container, Navbar, Modal } from "react-bootstrap";
import { isMobileDevice } from "../Utils/index";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import "./index.css";
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
 
 
const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [showModal, setShowModal] = useState(false);
 
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  
  const isMobileOrTabletDevice = isMobileDevice();
  let prevScrollPos = window.scrollY;
  
 
  
  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");
    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };
  
  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container>
            <div className="navcont">
              <Navbar.Brand className="ps-3">
                <div className="nav-logo">
                  <a
                    href={"https://www.swmc.com/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={"SWMC-Logo"}
                  >
                    <img
                      src={
                        "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
                      }
                      className="main_logo"
                      alt={"SWMC logo"}
                    />
                  </a>
                </div>
              </Navbar.Brand>
              
              <div className="nav-right-section">
                <button
                  onClick={handleShowModal}
                  className="apply-now-btn"
                  aria-label="Apply Now"
                >
                  Apply Now
                </button>
                
                <div className=" ">
                  <UserWayAccessibilityMenu
                    color="black"
                    width={40}
                    height={40}
                  />
                </div>
              </div>
            </div>
          </Container>
        </Navbar>

        {/* Modal for Borrower Lead Generation Tool */}
        <Modal 
          show={showModal} 
          onHide={handleCloseModal}
          size="lg"
          centered
        >
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title>Apply Now</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BorrowerLeadGenerationTool
            loanOfficerId=""
            branchCode="058"
            leadSrc="NET001"
            loanPurpKeyword=""
            formHeading="Apply Now"
            statesDomain="ny.swmc.com"
            domainNameConsent="swmc.com"
            language="en"
             />
          </Modal.Body>
        </Modal>
       
      </div>
    </>
  );
};
export default HeaderNavbar;